var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.59 2.626a1.626 1.626 0 0 1 2.298 0l4.336 4.332a1.627 1.627 0 0 1 0 2.3L9.034 21.45a.85.85 0 0 1-.601.249H3.776a1.626 1.626 0 0 1-1.626-1.626v-4.335c0-.431.171-.845.476-1.15L14.589 2.627Zm1.149 1.255L3.85 15.77V20h4.23L19.97 8.108l-4.231-4.227Z",
    fill: "var(--color-primary-800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.582 20.85c0-.47.38-.85.85-.85h11.641a.85.85 0 0 1 0 1.7H8.432a.85.85 0 0 1-.85-.85ZM11.712 5.503a.85.85 0 0 1 1.202 0l5.433 5.433a.85.85 0 0 1-1.202 1.202l-5.433-5.432a.85.85 0 0 1 0-1.203Z",
    fill: "var(--color-primary-800)"
  })));
};
export default SvgPencil;